import React from 'react'
import { PieChart, Pie} from 'recharts'

const PieChartGraph = props => {
  const renderLabel = entry => {
    return entry.name;
  }
  return (
    <PieChart width={330} height={230}>
      <Pie data={props.data} dataKey="value" innerRadius={20} outerRadius={50} fill="gray" nameKey="name" labelLine={true} label={renderLabel} />
    </PieChart>
  )
}

export default PieChartGraph
